import { IDeleteInspecaoObraOcorrenciaUseCase } from "../../../presentation/useCases/delete/delete_inspecao_obra_ocorrencia_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteInspecaoObraOcorrenciaUseCase
 */

export class DeleteInspecaoObraOcorrenciaUseCase implements IDeleteInspecaoObraOcorrenciaUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteInspecaoObraOcorrencia(
    idObra: number,
    idInspecaoObra: number,
    idInformacoesInspecaoObra: number,
  ): Promise<void> {
    await this.repository.deleteInspecaoObraOcorrencia(
      idObra,
      idInspecaoObra,
      idInformacoesInspecaoObra,
    );
  }
}
